import Swiper from "swiper";
import { Navigation } from "swiper/modules";

class FilterSlider {
  slider;
  constructor() {
    this.sliderInit();
    this.filterInit();
    this.filterSliderInit();
  }

  filterSliderInit = () => {
    const slider = new Swiper(".js-filter-options", {
      grabCursor: true,
      slidesPerView: "auto",
    });
  };

  sliderInit = () => {
    if (this.slider) {
      this.slider.update();
    }
    this.slider = new Swiper(".js-filter-slider", {
      modules: [Navigation],
      spaceBetween: 20,
      slidesPerView: "auto",
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: ".js-filter-slider-next",
        prevEl: ".js-filter-slider-prev",
      },
    });
  };

  fetchData = async (filter) => {
    const wrapper = document.querySelector(".js-filter-wrapper");
    let formData = new FormData();
    formData.append("action", "filter_slider");
    formData.append("filter", filter);
    wrapper.classList.add("animating");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.files;
    if (wrapper.querySelector(".swiper-slide")) {
      this.sliderInit();
    }
    wrapper.classList.remove("animating");
  };

  filterInit = () => {
    const filters = document.querySelectorAll(".js-slider-filter");
    filters.forEach((filter) => {
      filter.addEventListener("click", () => {
        filters.forEach((f) => {
          if (f != filter) {
            f.classList.remove("active");
          }
        });
        filter.classList.add("active");
        this.fetchData(filter.getAttribute("data-slug"));
      });
    });
  };
}
export default FilterSlider;

new FilterSlider();
